import { useEffect, useState } from "react";
import AppButton from "../elements/AppButton";
import useApiRequest from "../../helpers/api_request";
import { AxiosError } from "axios";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { BASE_URL } from "../../helpers/constants";
import { selectAccessToken } from "../../features/auth/authSlice";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { TypeDistrictData } from "../regions/RegionPage";
import useValueChains from "../../hooks/useValueChains";
import AppSpinner from "../elements/AppSpinner";

const CreateValueChainPage = () => {
    const [isSavingValueChain, setIsSavingValueChain] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("")
    const [district_id, setDistrictId] = useState("")
    const [subRegion, setSubRegion] = useState<number[]>([])
    const apiRequest = useApiRequest()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { id } = useParams();
    const [valueChainId, setValueChainId] = useState<number | null>(null);

    const { loadingValueChains, valueChains, getValueChains } = useValueChains();
    useEffect(() => {
        if (id != null) {
            const valueChain = valueChains.filter((item) => item.id == parseInt(id))
            if (valueChain.length > 0) {
                setName(valueChain[0].name)
                setDescription(valueChain[0].description as string)
                setDistrictId(valueChain[0].district_id as string)
                setValueChainId(valueChain[0].id)
                setSubRegion(valueChain[0].districts.map((item) => item.id));
            }
        }
    }, [valueChains])


    useEffect(() => {
        if (id != null) {
            getValueChains();
        }
    }, []);

    const [districtsData, setDistrictsData] = useState<TypeDistrictData[]>([]);
    useEffect(() => {
        getDistricts();
    }, [])
    const getDistricts = async () => {
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/districts",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setDistrictsData(response.data)
        }).catch((error) => {

        });
    }

    const saveVaueChain = async () => {
        if (name === "") {
            dispatch(showToastMessage({
                message: "Name is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return
        }
        setIsSavingValueChain(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/value-chain/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                name: name,
                description: description,
                subregions: subRegion,
                value_chain_id: valueChainId
            }
        }).then((response) => {
            setIsSavingValueChain(false)
            dispatch(showToastMessage({
                message: "Value Chain Saved saved",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            navigate("/value-chains")
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setIsSavingValueChain(false)
        });
    }


    const toggleSubRegions = (region: number) => {
        setSubRegion((prevRegion) => {
            const index = prevRegion.indexOf(region);
            if (index === -1) {
                // region does not exist, so add it to the array
                return [...prevRegion, region];
            } else {
                // region already exists, so remove it from the array
                const updatedRegions = [...prevRegion];
                updatedRegions.splice(index, 1);
                return updatedRegions;
            }
        });
    };
    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">

                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Value chains</h5>
                                    </div>
                                </li>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">
                                            {id == null ? "Create" : "Edit"}
                                        </h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    {
                        (loadingValueChains) ? <AppSpinner /> :
                            <div className=" h-fit flex-grow flex flex-col justify-center ">
                                <div className=" w-2/3 mt-3">
                                    <label className="block text-sm font-medium text-gray-700 ">Name</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)} className="form-input-2" type="text" />
                                </div>
                                <div className=" w-2/3 mt-3">
                                    <label className="block text-sm font-medium text-gray-700 ">Sub-regions</label>
                                    <div className="grid grid-cols-3 accent-green-700">
                                        {districtsData.map((item, key) => (
                                            <div key={key} className="flex items-center mt-3">
                                                <input
                                                    onChange={() => toggleSubRegions(item.id)}
                                                    id={item.name}
                                                    type="checkbox"
                                                    value=""
                                                    className="w-3.5 h-3.5 text-blue-600 bg-gray-100 rounded-full focus:ring-blue-500"
                                                    checked={subRegion.includes(item.id)}
                                                />
                                                <label htmlFor={item.name} className="ml-2 text-sm font-medium text-gray-600">
                                                    {item.name}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {/* <select value={district_id} onChange={(e) => setDistrictId(e.target.value)} name="" className="form-input-2" id="">
                                        <option value="">Select</option>
                                        {
                                            districtsData.map((item, key) => <option value={item.id} key={key}>{item.name}</option>)
                                        }
                                    </select> */}
                                </div>
                                <div className=" w-2/3 mt-4">
                                    <label htmlFor="" className="block text-sm font-medium text-gray-700 ">Description (optional)</label>
                                    <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="form-input-2" name="" id="" cols={30} rows={7}></textarea>
                                </div>
                                <div className="w-2/3 mt-4">
                                    <AppButton callBackFun={() => saveVaueChain()} showLoader={isSavingValueChain} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2" text="Save" />

                                </div>
                            </div>
                    }


                </div>
            </div>
        </div>
    )
}

export default CreateValueChainPage;